
export const RoleConstant = {
    Role: 'api/Role',
    ESAR_Admin: 'ESAR_Admin',
    ESAR_ReadOnly: 'ESAR_BusinessReadOnly',
    ESAR_Requestor: 'ESAR_Requestor',
    ESAR_StockingApprover: 'ESAR_StockingApprover',
    ESAR_MMD: 'ESAR_MMD',
};
